import { clsx } from 'clsx';

import { ButtonProps } from './Button';
import { button } from './Button.css';
import { IconLoadingLine } from '../Icon';
import { Tooltip, TooltipProps } from '../Tooltip';

export interface IconButtonProps
  extends Omit<ButtonProps, 'prefix' | 'suffix' | 'children' | 'alignCenter' | 'closable'> {
  icon: React.ReactNode;
  /** IconButton은 항상 호버시 툴팁. figma 버튼 레이어 레이블 이름 참고 */
  tooltipMessage: TooltipProps['content'];
}

export const IconButton: React.FC<IconButtonProps> = ({
  buttonType = 'normal',
  buttonSize = 'm',
  disabled,
  loading = false,
  icon,
  type = 'button',
  tooltipMessage,
  className,
  ...props
}) => {
  const isDisabled = disabled || loading;

  return (
    <Tooltip content={tooltipMessage}>
      <button
        className={clsx(
          button({
            buttonType,
            buttonSize,
            disabled: isDisabled,
            loading,
            iconOnly: true,
          }),
          className,
        )}
        type={type}
        disabled={isDisabled}
        {...props}
      >
        {loading ? <IconLoadingLine spin /> : icon ?? null}
      </button>
    </Tooltip>
  );
};
